export const MASKEDTYPE = {
    EMAIL: "Email",
    PHONE: "Phone",
    AADHAAR: "Aadhaar",
}
Object.freeze(MASKEDTYPE);